import keyMirror from 'keymirror'

export default keyMirror({
  UPLOAD_MEDIA_REQUEST: null,
  UPLOAD_MEDIA_SUCCESS: null,
  UPLOAD_MEDIA_FAILED: null
})
